if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){


    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    $('.sym-slides').slick({
        accessibility: false
    });

    $('.slick-prev').each(function(){
        $(this).html('Prev');
    }); 
 
    $('.tags-menu li').click(function(){
        const thisTag = $(this).attr('data-tag');
        $('.room').hide();
        $(`.tag-${thisTag}`).fadeIn();
        $('.tags-menu li').removeClass('active');
        $(this).addClass('active');
    });

    $('#all.tab-content').css("display", "block");

    $(".tabs-menu a").click(function(event) {
        event.preventDefault();
        $('.tabs-menu a').removeClass("active"); 
        $(this).addClass("active");
        var tab = $(this).attr("href");
        $(".tab-content").not(tab).css("display", "none");
        $(tab).fadeIn();
        setTimeout(function() {
            equalize();
        }, 50);
    });

    $('#booking-trigger').click(function(e){
        e.preventDefault();
        $('#booking-content').slideToggle();
    });

    $('.close-rfp').click(function(e){
        e.preventDefault();
        $('#booking-content').slideToggle();
    });
    
    $('.booking-trigger').click(function(e){
        e.preventDefault();
        $('#booking-content').slideToggle();
   		 });

})();